// Ames.ConfigurableItems.NonInventory.StockMessage
// -------------------------------------------------
// Non-inventory items (configurables, services, other charges) always come
// back from the Item Search API with isinstock = true, so SCA's native
// ProductLine.Stock.View never renders their Out of Stock Message.
//
// This wraps ProductLine.Stock.View.getContext (used by both the PDP
// "Product.Stock.Info" child view and the PLP cell "ItemViews.Stock") so that
// when the item's Out Of Stock Behavior is either
//   - "Allow back orders but display out-of-stock message"   (ENABLE)
//   - "Disallow back orders but display out-of-stock message" (DISABLE)
// and the Out of Stock Message field is not empty, the message renders the
// same way it does for inventory items and kits.
//
// It only touches the stock message: purchasability, quantity and pricing are
// left as-is (the item is still backorderable as far as NetSuite is concerned).
// If the InventoryOverride extension already flagged the item via
// sageStockStatus, that message wins and this module does nothing.
define("Ames.ConfigurableItems.NonInventory.StockMessage", [
  "underscore",
  "ProductLine.Stock.View",
], function (_, ProductLineStockView) {
  "use strict";

  var NON_INVENTORY_TYPES = ["NonInvtPart", "Service", "OthCharge"];

  function itemAttributes(model) {
    if (!model) return null;
    var item = (model.get && model.get("item")) || model;
    return item && item.attributes ? item.attributes : item;
  }

  // Accepts either the internal code (ENABLE / DISABLE) or the display label
  // the Item Search API returns ("Allow back orders but display out-of-stock
  // message", "Disallow back orders but display out-of-stock message").
  function behaviorDisplaysMessage(behavior) {
    if (!behavior) return false;
    var value = String(behavior).trim();
    if (value === "ENABLE" || value === "DISABLE") return true;
    return /display out-of-stock message/i.test(value);
  }

  function getNonInventoryOOSMessage(attrs) {
    if (!attrs) return null;
    if (!_.contains(NON_INVENTORY_TYPES, attrs.itemtype)) return null;
    if (!behaviorDisplaysMessage(attrs.outofstockbehavior)) return null;
    var message = attrs.outofstockmessage;
    if (message == null || String(message).trim() === "") return null;
    return String(message).trim();
  }

  return {
    mountToApp: function () {
      ProductLineStockView.prototype.getContext = _.wrap(
        ProductLineStockView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.rest(arguments));

          // InventoryOverride (Sage) already decided this item is OOS
          if (context.sageStockStatus === "outofstock") return context;
          // Native logic is already showing the OOS message
          if (context.showOutOfStockMessage) return context;

          var message = getNonInventoryOOSMessage(itemAttributes(this.model));
          if (!message) return context;

          context.showOutOfStockMessage = true;
          context.showInStockMessage = false;
          context.stockInfo = _.extend({}, context.stockInfo, {
            outOfStockMessage: message,
            showOutOfStockMessage: true,
          });
          return context;
        }
      );
    },
  };
});
